const homeDestinations = [
  { action: "View", subject: "MHD_Dashboard", path: "dashboard" },
  { action: "View", subject: "MHD_Applications", path: "applications" },
  {
    action: "View",
    subject: "MHD_GovnrApplications",
    path: "govnr/applications",
  },
  { action: "View", subject: "MHD_Expenses", path: "expenses" },
  {
    action: "View",
    subject: "MHD_GovnrExpenses",
    path: "govnr/expenses",
  },
  {
    action: "View",
    subject: "MHD_GovnrDisbursements",
    path: "govnr/disbursements",
  },
  {
    action: "View",
    subject: "MHD_GovnrChildTransfers",
    path: "govnr/transfers",
  },
];

export const getHomeDestination = (can) =>
  homeDestinations.find(({ action, subject }) => can(action, subject))?.path ??
  null;
